export default __webpack_public_path__ + "static/media/heart.ef632831.svg";